module.exports = __webpack_public_path__ + "static/img/arrow.a6819481.png";